import type { CoreApiClient } from "../client";
import { createAccountMutations } from "../mutations/account.mutations";
import { createAccountQueries } from "../queries/account.queries";

export const createAccountRepository = (api: CoreApiClient) => ({
  ...createAccountQueries(api),
  ...createAccountMutations(api),
});
